import React from 'react';
import {Radio} from 'antd';
import {Colors} from '../../styles/Colors';
import {GlobalStyleAttributes} from '../../styles/GlobalStyles';
import HStack from './Layout/HStack';
import AppText from './AppText';

const RadioListItem = (props) => {
    const {label, isSelected, onSelect, endContent, showBottomBorder = true, disabled = false} = props;

    const onRadioChange = (e) => {
        e.stopPropagation();
        if (!disabled) {
            onSelect();
        }
    };

    return (
        <div
            onClick={() => !disabled && onSelect()}
            style={{width: '100%', cursor: disabled ? 'not-allowed' : (isSelected ? 'default' : 'pointer'), opacity: disabled ? 0.55 : 1}}
        >
            <HStack
                alignItems={'center'}
                space={'0.75rem'}
                style={{
                    height: '48px',
                    padding: '0 12px',
                    backgroundColor: isSelected ? Colors.newDesign.lightBlue : Colors.newDesign.white,
                    ...(showBottomBorder ? {borderBottom: `1px solid ${Colors.borderColor}`} : {}),
                }}
            >
                <Radio checked={isSelected} disabled={disabled} onChange={onRadioChange} onClick={(e) => e.stopPropagation()}/>
                <AppText
                    fontSize={GlobalStyleAttributes.fonts.standard16}
                    color={disabled ? Colors.newDesign.darkGrey : (isSelected ? Colors.newDesign.mainBlue : Colors.newDesign.mainText)}
                    style={{flex: 1}}
                >
                    {label}
                </AppText>
                {endContent}
            </HStack>
        </div>
    );
};

export default RadioListItem;
